import SectionWrapper from '@/components/atoms/SectionWrapper';
import RequestsTable from '@/components/reports/dispute/RequestsTable';
import { Stats } from '@/components/reports/dispute/Stats';
import PeriodSelect from '@/components/reports/SharedComponents/PeriodSelect';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { resetDisputeFilters } from '@/store/slices/reportFiltersSlice';
import { setSearch, setPage, setModalId } from '@/store/slices/publicSlice';

export default function DisputesReports() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetDisputeFilters());
      dispatch(setSearch({ key: 'disputeReportSearch', value: '' }));
      dispatch(setPage(0));
      dispatch(setModalId(null));
    };
  }, [dispatch]);

  return (
    <SectionWrapper
      title={t('reports.dispute.title', 'Disputes reports')}
      desc={t(
        'reports.dispute.pageDesc',
        'All reported issues raised by users regarding orders or transactions, enabling admins to review, manage, and resolve conflicts efficiently.'
      )}
      actions={<PeriodSelect />}
    >
      <div className="space-y-6">
        <Stats />

        <RequestsTable />
      </div>
    </SectionWrapper>
  );
}
